import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { resolveId, getPostCover, isExperimentEnabled } from '@wix/communities-blog-client-common';
import { EXPERIMENT_USE_RESOLVED_COVER_IMAGE } from '@wix/communities-blog-experiments';

import { connect } from '../../../common/components/runtime-context';
import RecentPostsListItemWithCover from './recent-posts-list-item-with-cover';
import RecentPostsListItemWithoutCover from './recent-posts-list-item-without-cover';
import withFontClassName from '../../../common/hoc/with-font-class-name';
import styles from './recent-posts-list-item.scss';
import withMediaHosts from '../../../common/hoc/with-media-hosts';

export const RecentPostsListItem = (props) => {
  const { post, incrementPostLikeCount, isMetadataFooterVisible, imageHost, videoHost, useResolvedCoverImage } = props;
  const onLikeClick = () => incrementPostLikeCount(resolveId(post));
  const {
    shouldRender: withCover,
    imageMetadata,
    videoMetadata,
  } = getPostCover(post, imageHost, videoHost, useResolvedCoverImage);
  const postLink = `/${post.slug}`;
  const Component = withCover ? RecentPostsListItemWithCover : RecentPostsListItemWithoutCover;
  const componentProps = {
    postLink,
    type: 'recentPosts',
    onLikeClick,
    imageMetadata,
    videoMetadata,
    ...props,
  };

  const articleStyle = { paddingTop: `calc(56.25% + ${isMetadataFooterVisible ? '148px' : '103px'})` };

  return (
    <article className={styles.article} tabIndex="0" data-hook="recent-post-list-item" style={articleStyle}>
      <div className={styles.container}>
        <Component {...componentProps} />
      </div>
    </article>
  );
};

RecentPostsListItem.propTypes = {
  post: PropTypes.object.isRequired,
  incrementPostLikeCount: PropTypes.func.isRequired,
  isMetadataFooterVisible: PropTypes.bool.isRequired,
  imageHost: PropTypes.string.isRequired,
  videoHost: PropTypes.string.isRequired,
  useResolvedCoverImage: PropTypes.bool,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  incrementPostLikeCount: actions.incrementPostLikeCount,
  useResolvedCoverImage: isExperimentEnabled(state, EXPERIMENT_USE_RESOLVED_COVER_IMAGE),
});

// prettier-ignore
export default flowRight(
  withFontClassName,
  withMediaHosts,
  connect(mapRuntimeToProps),
)(RecentPostsListItem);
